import moment from 'moment'

export const getUrlParameter = (queryString, name) => {
  if (queryString.indexOf('?') === 0) {
    return getUrlParameter(queryString.substr(1), name)
  }

  for (const pair of queryString.split('&')) {
    const [ key, value ] = pair.split('=').map(component => decodeURIComponent(component))
    if (key === name) {
      return value
    }
  }

  return null
}

// Pulls date preselected date string from URL
export const getDateUrlParameter = (queryString, key = 'filter[date]') => {
  const value = getUrlParameter(queryString, key)
  if (!value) {
    return null
  }

  const day = value.substr(0, 10)
  let offset = value.substr(10, value.length)
  if (!offset) {
    offset = "+0000"
  }

  const date = moment(day + 'T00:00:00' + offset)

  // Return the date string if it is valid
  if (date.isValid()) {
    return date.toISOString()
  }

  return null
}

export const getTimeFilter = (queryString) => {
  const value = getUrlParameter(queryString, 'filter[time]')
  if (!value) {
    return null
  }

  const date = moment(value)

  if (date.isValid()) {
    return value
  }

  return null
}

const getMatches = (str, regex) => {
  let matches = []
  let match

  // eslint-disable-next-line
  while (match = regex.exec(str)) {
    matches.push(match)
    if (regex.lastIndex === match.index) {
      regex.lastIndex++
    }
  }

  return matches
}

const getSettingParams = (queryString, settingKey) => {
  let answers = []
  const regex = new RegExp(`${settingKey}\\[(.+?)\\]=(.*?)(&|$)`, 'gi')
  const matches = getMatches(queryString, regex)

  for (const match of matches) {
    answers.push({
      key: match[1],
      value: match[2],
    })
  }

  return answers
}

export const getAnswersFromUrl = () => {
  const searchString = decodeURI(window.location.search)
  const answerParams = getSettingParams(searchString, 'answer')
  return answerParams.reduce((obj, answer) => {
    obj[answer.key] = decodeURIComponent(answer.value)
    return obj
  }, {})
}

export const getOptionsFromUrl = () => {
  const searchString = decodeURI(window.location.search)
  const optionParams = getSettingParams(searchString, 'option')
  return optionParams.reduce((obj, option) => {
    obj[option.key] = decodeURIComponent(option.value)
    return obj
  }, {})
}
